import xdk from '@accedo/xdk-core'
import isTizen from '@accedo/xdk-device-samsung-tizen/esm/detection'
import { generateUniqueId, logGenericDatadogError } from './datadog'
import { getAppVersion } from './info'
import { isStagingEnabled } from './settingsUtils'

export const getCoreApiUrl = () => {
  return isStagingEnabled() ? 'https://staging-api.flosports.tv' : 'https://api.flosports.tv'
}

export const getLiveApiUrL = () => {
  return isStagingEnabled()
    ? 'https://staging-live-api-3.flosports.tv'
    : 'https://live-api-3.flosports.tv'
}

export const getEntitlementsUrl = () => {
  return isStagingEnabled()
    ? 'https://entitlements.stag-aws.flokubernetes.com'
    : 'https://entitlements.aws.flokubernetes.com'
}

export const getOffersUrl = () => {
  return isStagingEnabled()
    ? 'https://offers.stag-aws.flokubernetes.com'
    : 'https://offers.aws.flokubernetes.com'
}

export const getPaymentsUrl = () => {
  return isStagingEnabled()
    ? 'https://payments.stag-aws.flokubernetes.com'
    : 'https://payments.aws.flokubernetes.com'
}

export const getContinueWatchingApiUrL = () => {
  return isStagingEnabled()
    ? 'https://continue-watching.stag.flokubernetes.com'
    : 'https://continue-watching.flokubernetes.com'
}

/**
 * Network request helper function for FloSports adding required headers for all
 * network requests.
 * @param url The url to request.
 * @param options The options to pass in the request.
 * @returns The network response.
 */
export const floFetch = async (
  url: string,
  options: RequestInit,
): Promise<Response | ErrorType> => {
  try {
    const headers = {
      'x-flo-app': `${xdk.platform}-app`,
      'x-flo-app-version': getAppVersion(),
      ...(isTizen && {
        'x-datadog-sampling-priority': '1',
        'x-datadog-origin': 'rum',
        'x-datadog-trace-id': generateUniqueId(),
        'x-datadog-parent-id': generateUniqueId(),
      }),
      ...options.headers,
    }

    const response = await fetch(`${url}`, {
      ...options,
      headers,
    })

    if (!response.ok) {
      logGenericDatadogError(response?.status?.toString(), response?.statusText)

      return {
        error: response?.statusText,
        body: await response?.json(),
        status: response?.status,
        isNetworkError: false,
      } as ErrorType
    }

    return response
  } catch (error) {
    logGenericDatadogError(error?.name, error?.message, error)
    console.error(error)

    const isNetworkError =
      error instanceof TypeError &&
      (error.message === 'Failed to fetch' ||
        error.message === 'NetworkError when attempting to fetch resource.')

    return {
      error: error,
      status: isNetworkError ? 0 : -1,
      isNetworkError,
    } as ErrorType
  }
}
